import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Field, inputCls } from "@/components/common";

const OTHER = "OTHER";

function Choice({ on, onClick, title, note, price, testId }: any) {
  return (
    <button type="button" onClick={onClick} aria-pressed={on} data-testid={testId}
      className={`w-full text-left border p-4 flex items-start gap-4 transition-colors ${on ? "border-neutral-900 bg-white" : "border-neutral-200 bg-white/60 hover:border-neutral-400"}`}>
      <span className={`mt-1 h-4 w-4 rounded-full border flex-none ${on ? "border-[5px] border-neutral-900" : "border-neutral-400"}`} />
      <span className="flex-1"><span className="block text-sm font-medium">{title}</span><span className="block text-xs text-neutral-500 mt-1">{note}</span></span>
      <span className="text-sm">{price}</span>
    </button>
  );
}

export function DeliveryOptions() {
  const { ship, setShip, quote } = useCart();
  const [cfg, setCfg] = useState<any>(null);
  useEffect(() => { api.get("/shipping/countries").then((r) => setCfg(r.data)); }, []);
  if (!cfg) return null;
  const overnightOk = cfg.overnight.countries.includes(ship.country);
  const blocked = quote?.ship_ok === false;
  return (
    <section className="space-y-4" data-testid="delivery-options">
      <Field label="Shipping to">
        <select value={ship.country} onChange={(e) => setShip({ country: e.target.value, delivery: cfg.overnight.countries.includes(e.target.value) ? ship.delivery : "standard" })} className={inputCls} data-testid="checkout-country-select">
          {cfg.countries.map((c: any) => <option key={c.code} value={c.code}>{c.name}</option>)}
          <option value={OTHER}>My country isn't listed</option>
        </select>
      </Field>
      {blocked ? (
        <div className="border border-[var(--c-primary)]/30 bg-[var(--c-muted)] p-5 text-sm space-y-3" data-testid="checkout-country-unsupported">
          <p className="font-display text-xl">We'd love to find a way to you</p>
          <p className="text-neutral-700">We don't yet ship to your country, so checkout is paused for now. Our concierge can often arrange something special — tell us where you are and we'll be in touch.</p>
          <Link to="/pages/contact" className="inline-block btn-line px-6 py-3 text-[11px] tracking-[0.22em] uppercase" data-testid="checkout-country-concierge">Ask our concierge</Link>
          <p className="text-xs text-neutral-500"><Link to="/pages/shipping" className="underline">See where we ship</Link></p>
        </div>
      ) : (
        <div className="space-y-3">
          <p className="eyebrow text-[10px] text-neutral-500">Delivery</p>
          <Choice on={ship.delivery !== "overnight" || !overnightOk} onClick={() => setShip({ ...ship, delivery: "standard" })} testId="delivery-standard"
            title="Complimentary insured shipping" note="FedEx or DHL Express, fully insured, signature on delivery" price="Free" />
          {overnightOk && <Choice on={ship.delivery === "overnight"} onClick={() => setShip({ ...ship, delivery: "overnight" })} testId="delivery-overnight"
            title="FedEx Overnight" note="Speeds up transit only — Made-to-Order pieces still take 4–6 weeks to craft" price={money(cfg.overnight.fee)} />}
        </div>
      )}
    </section>
  );
}
